import { type Place } from "@xapp/components";
import { Template, TemplateId, TEMPLATES } from "constants/templates";
import { existsAndNotEmpty } from "stentor-utils";

export { Template, TemplateId };

const PLACE_TYPES_TO_TEMPLATE: Record<string, TemplateId> = {
    //  accounting: "financial-services",
    //  airport: "travel",
    //  amusement_park: "travel",
    //  aquarium: "travel",
    //  art_gallery: "travel",
    //  atm: "financial-services",
    //  bank: "financial-services",

    // Strategy here is just define the know we have and the reset will default to contact-capture
    electrician: "home-services-contractors",
    lawyer: "legal-services",
    locksmith: "contact-capture",
    painter: "home-services-contractors",
    plumber: "home-services-contractors",
    roofing_contractor: "home-services-contractors",
};

/**
 * Returns a template from a template ID, undefined if it can't find it.
 */
export const getTemplateFromId = (templateId: TemplateId): Template | undefined => {
    if (!templateId) {
        return undefined;
    }
    return TEMPLATES.find((template) => template.id.toLowerCase() === templateId.toLowerCase());
};

/**
 * Get a template from a place
 *
 * @param place
 */
export const getTemplateFromPlace = (place: Place): Template => {
    // Look for matches in the TEMPLATES
    const template = TEMPLATES.find((template) => {
        if (existsAndNotEmpty(template.matches)) {
            // take the first type from the place
            const placeType = place.types?.[0];
            // If we have a place type, check if it matches
            if (placeType) {
                // Check if the template matches the place type
                return template.matches?.some((match) => match === placeType);
            }
        }
        return false;
    });

    if (template) {
        // If we found a template, return it
        return {
            ...template,
        };
    }

    // One way, absolutely defined
    const placeType = place.types?.find((type) => PLACE_TYPES_TO_TEMPLATE[type]);
    const templateId = placeType ? PLACE_TYPES_TO_TEMPLATE[placeType] : "contact-capture";

    const firstType = place.types?.[0] || "Contact Capture";

    const dirtyPlaceType = placeType ? placeType : firstType;

    // clean placeType, remove spaces and lowercase and capitalize
    let name = dirtyPlaceType.replace(/_/g, " ");
    // capitalize first letter
    name = name.charAt(0).toUpperCase() + name.slice(1);

    // OK!  Now create a Template object
    return {
        name,
        id: templateId,
        url: `https://templates.xapp.ai/${templateId}.json`,
    };
};
